import CloseIcon from '@mui/icons-material/Close';
import { alpha, Chip, chipClasses, ChipProps, styled } from '@mui/material';

import { getAlgorithmChipColor } from '../../common';

interface AlgorithmChipProps extends ChipProps {
  textColor: string;
}

const AlgorithmChip = styled((props: ChipProps) => {
  const { textColor, ...others } = props as AlgorithmChipProps;

  return <Chip {...others} variant='filled' deleteIcon={<CloseIcon />} />;
})<AlgorithmChipProps>(({ textColor, theme }) => {
  const { text, bgColor } = getAlgorithmChipColor(
    textColor,
    theme.palette.mode
  );

  return {
    fontFamily: theme.typography.subtitleNumbers.fontFamily,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: text,
    backgroundColor: alpha(bgColor, 0.5),

    [`& .${chipClasses.deleteIcon}`]: {
      color: text,
    },
    [`& .${chipClasses.deleteIcon}:hover`]: {
      color: alpha(text, 0.6),
    },
  };
});

export default AlgorithmChip;
